<div class="container-fluid p-3">
  <div class="col-12">
    <div class="reportFrame">
      <div class="formFrame">
        <div class="reportForm">
          <form [formGroup]="reportForm" (ngSubmit)="updateReport()">
            <!-- Show selector if there are multiple companies -->
            <ng-container *ngIf="companiesData.length > 1; else singleCompany">
              <div class="form groupHeader">
                  <label>{{ 'COMPANY' | translate }}</label>
              </div>
              <div class="form dropdown">
                <ng-select 
                  [clearable]="false" 
                  [attr.aria-label]="'PLEASE_SELECT_COMPANY' | translate"
                  [placeholder]="'PLEASE_SELECT_COMPANY' | translate"
                  class="mb-2"
                  [ngClass]="{ 'is-invalid': reportForm.controls.companySelector.touched && reportForm.controls.companySelector.errors }" 
                  bindLabel="name" 
                  bindValue="id" 
                  [items]="companiesData" 
                  formControlName="companySelector">
                </ng-select>
                <div *ngIf="reportForm.controls.companySelector.touched && reportForm.controls.companySelector.errors" class="invalid-feedback">
                  <div *ngIf="reportForm.controls.companySelector.errors.required">{{ 'PLEASE_SELECT_COMPANY' | translate }}</div>
                </div>
              </div>
            </ng-container>
            <ng-template #singleCompany>
              <input type="hidden" formControlName="companySelector" [value]="selectedCompanyId">
            </ng-template>

              <div>
                  <div class="formGroup dateSelect">
                      <div class="form groupHeader">
                          <label>{{ 'SELECT_REPORT_PERIOD' | translate }}</label>
                      </div>
                      <div class="form dropdown">
                        <ng-select 
                          [clearable]="false" 
                          [attr.aria-label]="'SELECT_PERIOD' | translate"
                          [placeholder]="'SELECT_PERIOD' | translate"
                          class="mb-2"
                          (change)="onReportPeriodChange($event)"
                          bindLabel="title" 
                          bindValue="key" 
                          [items]="reportPeriods"
                          formControlName="key">
                        </ng-select>
                      </div>
                      <div class="dateRange">
                          <div class="form dateInput">
                              <label class="sr-only" for="startDate">{{ 'START' | translate }}</label>
                              <input type="date" [readonly]="datesReadonly" formControlName="startDate"
                              class="form-control form-date date-custom" [ngClass]="{ 'is-invalid': reportForm.controls.startDate.errors }" />
                              <div *ngIf="reportForm.controls.startDate.errors" class="invalid-feedback">
                              <div *ngIf="reportForm.controls.startDate.errors.required">{{ 'SELECT_PERIOD' | translate }}</div>
                              </div>
                          </div>

                          <div class="form dateInput">
                              <span style="margin: 0 6px;">&mdash;</span>
                          </div>

                          <div class="form dateInput">
                              <label class="sr-only" for="stopDate">{{ 'END' | translate }}</label>
                              <input type="date" [readonly]="datesReadonly" formControlName="stopDate"
                              class="form-control form-date date-custom" [ngClass]="{ 'is-invalid': reportForm.controls.stopDate.errors }" />
                              <div *ngIf="reportForm.controls.stopDate.errors" class="invalid-feedback">
                              <div *ngIf="reportForm.controls.stopDate.errors.required">{{ 'SELECT_PERIOD' | translate }}</div>
                              </div>
                          </div>
                    </div>
                  </div>
                  <div class="formGroup">
                      <div class="form submit">
                            <button type="submit" class="btn btn-primary mb-2">{{ 'RUN_REPORT' | translate }}</button>
                      </div>
                  </div>
              </div>
          </form>
      </div>
      </div>
      <div class="reportData">
        <ng-container *ngIf="loading; else dataContent">
          <div class="loading">
            <div class="la-ball-spin-clockwise la-2x">
              <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
            </div>
          </div>
        </ng-container>
        <ng-template #dataContent>
          <ng-container *ngIf="companyMetaData.length || companyGoogleData.length">
            <h2>{{ getActiveCompanyName() }}</h2>
            <strong>{{ 'REPORTS_QUICK_REFERENCE_DISCLAIMER' | translate }}</strong>
            <br>
            <em>{{ 'MONTHLY_BUDGET_NOTE' | translate }}</em>
            <div class="dv-custom-navs reports-brand-tabs" style="margin-top: 1em;">
              <ul class="nav nav-tabs reports-brand-tabs__nav" id="reportTabs" role="tablist">
                <li class="nav-item" id="meta-data-tab" [class.rm-tab-active]="activeTab === 'meta'" role="tab" aria-controls="meta-data" aria-selected="true">
                  <button type="button" class="nav-link" [class.active]="activeTab === 'meta'" (click)="activeTab = 'meta'">{{ 'PLATFORMS.META' | translate }}</button>
                </li>
                <li class="nav-item" id="google-data-tab" [class.rm-tab-active]="activeTab === 'google'" role="tab" aria-controls="google-data" aria-selected="false">
                  <button type="button" class="nav-link" [class.active]="activeTab === 'google'" (click)="activeTab = 'google'">{{ 'PLATFORMS.GOOGLE' | translate }}</button>
                </li>
              </ul>
            </div>
            <div class="tab-content" id="reportTabsContent">
              <div class="tab-pane fade" [class.show]="activeTab === 'meta'" [class.active]="activeTab === 'meta'" id="meta-data" role="tabpanel" aria-labelledby="meta-data-tab">
                <div style="padding-top: 10px;">
                  <app-report-datatable 
                    [iSortColumn]="'campaign_name'"
                    [iSortDirection]="'asc'"
                    [iColumns]="defaultMetaColumns" 
                    [iData$]="companyMetaData"
                    [iTotalCount]="companyMetaData.length"
                    [iShowFooter]="companyMetaData.length > defaultPageSize"
                    [iPageSize]="defaultPageSize"
                    [iTotalData]="companyMetaTotals"
                    [iAverageData]="companyMetaAverages"
                    [iReportTitle]="'PLATFORMS.META' | translate"
                  >
                  </app-report-datatable>
                </div>
              </div>
              <div class="tab-pane fade" [class.show]="activeTab === 'google'" [class.active]="activeTab === 'google'" id="google-data" role="tabpanel" aria-labelledby="google-data-tab">
                <div style="padding-top: 10px;">
                  <app-report-datatable 
                    [iSortColumn]="'campaign_name'"
                    [iSortDirection]="'asc'"
                    [iColumns]="defaultGoogleColumns" 
                    [iData$]="companyGoogleData"
                    [iTotalCount]="companyGoogleData.length"
                    [iShowFooter]="companyGoogleData.length > defaultPageSize"
                    [iPageSize]="defaultPageSize"
                    [iTotalData]="companyGoogleTotals"
                    [iAverageData]="companyGoogleAverages"
                    [iReportTitle]="'PLATFORMS.GOOGLE' | translate"
                  >
                  </app-report-datatable>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-template>

      </div>
    </div>
  </div>
</div>